import { styled, keyframes } from '@grupoboticario/flora-react-system'
import { CircumferenceRadiusIcon } from '@grupoboticario/flora-react-icons'

const rotate = keyframes({
  '0%': { transform: 'rotate(0)' },
  '100%': { transform: 'rotate(360deg)' },
})

export const StyledHelperText = styled('div', {
  fontFamily: 'inherit',
  display: 'flex',
  alignItems: 'center',
  gap: '$1',
  marginTop: '$2',
  color: '$nonInteractiveAuxiliar',

  variants: {
    status: {
      neutral: {
        '& svg': {
          color: '$statusInfoNonInteractiveEmphasis',
        },
      },
      success: {
        '& svg': {
          color: '$statusSuccessNonInteractiveEmphasis',
        },
      },
      error: {
        '& svg': {
          color: '$statusErrorNonInteractiveEmphasis',
        },
      },
      warning: {
        '& svg': {
          color: '$statusAlertNonInteractiveEmphasis',
        },
      },
      loading: {
        '& svg': {
          color: '$nonInteractivePredominant',
        },
      },
      disabled: {
        color: '$disabledContent',

        '& svg': {
          color: 'inherit',
        },
      },
    },
    surfaceColor: {
      dark: {
        color: '$nonInteractiveAltAuxiliar',
      },
      light: {},
    },
  },
  compoundVariants: [
    {
      surfaceColor: 'dark',
      status: 'neutral',
      css: {
        '& svg': {
          color: '$statusInfoNonInteractiveAltEmphasis',
        },
      },
    },
    {
      surfaceColor: 'dark',
      status: 'success',
      css: {
        '& svg': {
          color: '$statusSuccessNonInteractiveAltEmphasis',
        },
      },
    },
    {
      surfaceColor: 'dark',
      status: 'error',
      css: {
        '& svg': {
          color: '$statusErrorNonInteractiveAltEmphasis',
        },
      },
    },
    {
      surfaceColor: 'dark',
      status: 'warning',
      css: {
        '& svg': {
          color: '$statusAlertNonInteractiveAltEmphasis',
        },
      },
    },
    {
      surfaceColor: 'dark',
      status: 'loading',
      css: {
        '& svg': {
          color: '$nonInteractiveAltPredominant',
        },
      },
    },
    {
      surfaceColor: 'dark',
      status: 'disabled',
      css: {
        color: '$disabledAltContent',

        '& svg': {
          color: 'inherit',
        },
      },
    },
  ],
})

export const Content = styled('div', {
  width: '100%',
  fontFamily: 'inherit',
  fontSize: '$auxiliar',
  fontWeight: 'regular',
  lineHeight: '$none',
})

export const LoadingIcon = styled(CircumferenceRadiusIcon, {
  animationName: `${rotate}`,
  animationDuration: '800ms',
  animationTimingFunction: 'linear',
  animationIterationCount: 'infinite',
})
